import { ReactElement } from 'react';
import { getSchema } from '@localstack/services';
import { GetWebFunctionEndpointResponse } from '@localstack/types';

import { MagicDetails } from '../../magic/MagicDetails';

export interface LambdaWebEndpointDetailsProps {
  data?: Optional<Partial<GetWebFunctionEndpointResponse>>;
}
export const LambdaWebEndpointDetails = ({ data }: LambdaWebEndpointDetailsProps): ReactElement => (
  <MagicDetails schema={getSchema('LambdaWeb')} entry="GetWebFunctionEndpointResponse" data={data} title="Endpoint" />
);
